import React from "react";
import { FormControl, Select, MenuItem } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  getTimezoneOffset,
  changeUtcOffset,
  changeUtcOffsetToMinutes
} from '../utils/date-time-utils'

export interface DateTimeComponentProps {
  startDate: Date | null;
  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>;
  setConfirmedStartDate: React.Dispatch<React.SetStateAction<Date | null>>;
  endDate: Date | null;
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>;
  setConfirmedEndDate: React.Dispatch<React.SetStateAction<Date | null>>;
  timezoneOffset: string;
  setTimezoneOffset: React.Dispatch<React.SetStateAction<string>>;
  defaultTimezoneOffset: string;
};

export default function DateTimeComponent (props: DateTimeComponentProps) {
  const {
    startDate,
    setStartDate,
    setConfirmedStartDate,
    endDate,
    setEndDate,
    setConfirmedEndDate,
    timezoneOffset,
    setTimezoneOffset,
  } = props;

  // get system UTC/timezone offset
  const systemOfffsetMinute = getTimezoneOffset() * (-1);

  // available UTC/timezone offsets
  const avaiableTimezoneOffsets = [
    'UTC-12:00',
    'UTC-11:00',
    'UTC-10:00',
    'UTC-09:30',
    'UTC-09:00',
    'UTC-08:00',
    'UTC-07:00',
    'UTC-06:00',
    'UTC-05:00',
    'UTC-04:00',
    'UTC-03:30',
    'UTC-03:00',
    'UTC-02:00',
    'UTC-01:00',
    'UTC+00:00',
    'UTC+01:00',
    'UTC+02:00',
    'UTC+03:00',
    'UTC+03:30',
    'UTC+04:00',
    'UTC+04:30',
    'UTC+05:00',
    'UTC+05:30',
    'UTC+05:45',
    'UTC+06:00',
    'UTC+06:30',
    'UTC+07:00',
    'UTC+08:00',
    'UTC+08:45',
    'UTC+09:00',
    'UTC+09:30',
    'UTC+10:00',
    'UTC+10:30',
    'UTC+11:00',
    'UTC+12:00',
    'UTC+12:45',
    'UTC+13:00',
    'UTC+14:00'
  ];

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1em',
          justifyContent: 'left',
          marginLeft: '0.5em'
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateTimePicker
            label="Start Date/Time"
            value={startDate}
            onChange={(newValue) => {
              setStartDate(newValue);
            }}
            onAccept={() => {
              // considering UTC/timezone offset
              setConfirmedStartDate(
                startDate != null
                  ? changeUtcOffset(changeUtcOffset(startDate, systemOfffsetMinute), (-1) * changeUtcOffsetToMinutes(timezoneOffset))
                  : startDate
              );
            }}
            slotProps={{
              textField: {
                size: 'small',
              }
            }}
          />
          <DateTimePicker
            label="End Date/Time"
            value={endDate}
            onChange={(newValue) => {
              setEndDate(newValue);
            }}
            onAccept={() => {
              // considering UTC/timezone offset
              setConfirmedEndDate(
                endDate != null
                  ? changeUtcOffset(changeUtcOffset(endDate, systemOfffsetMinute), (-1) * changeUtcOffsetToMinutes(timezoneOffset))
                  : endDate
              );
            }}
            slotProps={{
              textField: {
                size: 'small',
              }
            }}
          />
          {/* add UTC/timezone offset dropdown */}
          <div
            style={{
              textAlign: 'left',
              marginLeft: '-0.5em',
            }}
          >
            <FormControl
              sx={{
                m: 1,
              }}
              size="small"
            >
              <Select
                value={timezoneOffset}
                onChange={(event) => {
                  // need to change confirmedStartDate and confirmedEndDate
                  setTimezoneOffset(event.target.value);
                  setConfirmedStartDate(
                    startDate != null
                      ? changeUtcOffset(changeUtcOffset(startDate, systemOfffsetMinute), (-1) * changeUtcOffsetToMinutes(event.target.value))
                      : startDate
                  );
                  setConfirmedEndDate(
                    endDate != null
                      ? changeUtcOffset(changeUtcOffset(endDate, systemOfffsetMinute), (-1) * changeUtcOffsetToMinutes(event.target.value))
                      : endDate
                  );
                }}
              >
                {avaiableTimezoneOffsets.map((offsetValue) => (
                  <MenuItem key={offsetValue} value={offsetValue}>
                    {offsetValue}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </LocalizationProvider>
      </div>
    </>
  );
};
